import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ username: "", email: "", password: "", confirm: "" });
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!form.username || !form.email || !form.password) return toast.error("Sab fields zaroori hain");
    if (form.password !== form.confirm) return toast.error("Passwords match nahi kar rahe");
    if (form.password.length < 6) return toast.error("Password 6 characters se kam nahi hona chahiye");
    setLoading(true);
    try {
      const user = await register(form.username, form.email, form.password);
      toast.success(`Account ban gaya! Khush aamdeed, ${user.username}`);
      nav("/");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Account nahi bana");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6">
      <div className="w-full max-w-md border border-[#2A2A2D] bg-[#121214] p-10">
        <div className="overline text-[#B79C7B] mb-3">ShiaTunes</div>
        <h1 className="font-serif text-3xl text-ivory">Register karein</h1>
        <p className="text-sm text-[#A1A1AA] mt-2">
          Pehle se account hai?{" "}
          <Link to="/login" className="text-[#B79C7B] hover:underline">Login karein</Link>
        </p>

        <form onSubmit={onSubmit} className="mt-8 space-y-4">
          <input
            placeholder="Username"
            value={form.username}
            onChange={(e) => setForm({ ...form, username: e.target.value })}
            className="w-full h-12 bg-[#0A0A0B] border border-[#2A2A2D] focus:border-[#B79C7B] outline-none px-4 text-ivory"
          />
          <input
            type="email"
            placeholder="Email"
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
            className="w-full h-12 bg-[#0A0A0B] border border-[#2A2A2D] focus:border-[#B79C7B] outline-none px-4 text-ivory"
          />
          <input
            type="password"
            placeholder="Password (6+ characters)"
            value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })}
            className="w-full h-12 bg-[#0A0A0B] border border-[#2A2A2D] focus:border-[#B79C7B] outline-none px-4 text-ivory"
          />
          <input
            type="password"
            placeholder="Password dobara likhein"
            value={form.confirm}
            onChange={(e) => setForm({ ...form, confirm: e.target.value })}
            className="w-full h-12 bg-[#0A0A0B] border border-[#2A2A2D] focus:border-[#B79C7B] outline-none px-4 text-ivory"
          />
          <button
            type="submit"
            disabled={loading}
            className="w-full h-12 bg-[#8A2E2E] hover:bg-[#A33B3B] transition-colors text-sm tracking-widest disabled:opacity-50"
          >
            {loading ? "..." : "ACCOUNT BANANA"}
          </button>
        </form>
      </div>
    </div>
  );
}
